/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ErrorResponse = zod.object({
  code: zod.string().describe('Stable machine-readable error code'),
  error: zod.literal(true).describe('Always true; marker that this body represents an error'),
  errorList: zod
    .array(zod.string())
    .optional()
    .describe('Optional list of secondary error messages'),
  issues: zod
    .array(zod.unknown())
    .optional()
    .describe('Optional validation issues emitted for schema failures'),
  message: zod.string().describe('Human-readable error message'),
  metadata: zod
    .unknown()
    .optional()
    .describe('Optional structured metadata describing the error context'),
});

export type ErrorResponse = zod.input<typeof ErrorResponse>;
export type ErrorResponseOutput = zod.output<typeof ErrorResponse>;
